<!-- If both top and side navigations are there -->
<div [innerHTML]="companyCustomCss | safe : 'html'"></div>
<div>
  @if (isBothNavigation || isOnlyTopNavigation) {
    <app-top-bar
      [selectedModule]="selectedModule"
      [isBothNavigation]="isBothNavigation"
      (menuCollapsedStatus)="changeToggleMenuStatus($event)"
    ></app-top-bar>
  }
  @if (isBothNavigation) {
    <app-side-bar
      [selectedModule]="selectedModule"
      [isMenuCollapsed]="isMenuCollapsed"
    ></app-side-bar>
  }
  <div
    [ngClass]="{
      'top-spacer-100': isBothNavigation || isOnlyTopNavigation,
      'left-spacer-200': isBothNavigation && !isMenuCollapsed,
      'left-spacer-90': isBothNavigation && isMenuCollapsed,
      'top-spacer-185': isTopSpacer185()
    }"
    >
    <router-outlet></router-outlet>
  </div>
</div>
<!-- Loading component. -->
<app-loader></app-loader>
@if (isOffline) {
  <app-online-switch
    [initialState]="true"
    class="onlineSwitchPlaybooks"
  ></app-online-switch>
}

@if (loggedInUserRole == 'SuperVPlaybookAdmin') {
  <i
    (click)="goToBeta()"
    role="button"
    title="Checkout vPlaybook Beta"
    class="material-icons gotoBetaBtn p-1"
    style="cursor: pointer"
    >info</i
    >
  }
